import { graphql } from 'react-relay';

export const shippingDetailsLocationAddPartialAddressMutation = graphql`
    mutation shippingDetailsLocationAddPartialAddressMutation(
        $input: addPartialShippingAddressInput!
    ) {
        addPartialShippingAddress(input: $input) {
            address {
                serviceId
                zipCode
                country
            }
        }
    }
`;
